import {FOCUSABLE_ELEMENTS_SELECTOR} from '../constants/focusableElementsSelector';

/**
 * Finds the first focusable element within a container element.
 *
 * This utility is particularly useful for focus management in modals, dialogs,
 * and other components where you need to programmatically focus the first
 * interactive element.
 *
 * @param container - The container element to search within
 * @returns The first focusable element or null if none found
 *
 * @example
 * const dialogRef = useRef<HTMLDivElement>(null);
 *
 * useEffect(() => {
 *   if (isOpen) {
 *     const firstFocusable = findFirstFocusableElement(dialogRef.current);
 *     firstFocusable?.focus();
 *   }
 * }, [isOpen]);
 */
export const findFirstFocusableElement = (container: HTMLElement | null): HTMLElement | null => {
  if (!container) {
    return null;
  }

  const focusableElements = container.querySelectorAll<HTMLElement>(FOCUSABLE_ELEMENTS_SELECTOR);
  return focusableElements.length > 0 ? focusableElements[0] : null;
};
